<template>
    <div class="relative font-freizeit">
        <input
            type="text"
            name="signature-input"
            id="signature-input"
            ref="signature"
            v-model="signature"
            @input="validateSignature"
            @focus="openKeyboard"
            @blur="closeKeyboard"
            maxlength="16"
            :class="[ hasProfanity ? 'border-bleed text-bleed' : 'border-black' ]"
            class="border-b rounded-none focus:outline-none pb-1 h-8 lg:h-12 w-full bg-transparent text-2xl sm:text-3xl"
        />

        <button
            @click="enableEditSignature"
            @keyup.enter="enableEditSignature"
            type="button"
            class="absolute right-0 top-5 lg:bottom-5"
        >
            <img
                src="../assets/icons/edit.svg"
                alt="edit"
                width="12"
                height="12"
            >
        </button>

        <label
            for="signature-input"
            class="block font-freizeit text-xxs sm:text-sm"
        >
            {{ $t('BOTTLED_FOR') }}
        </label>
    </div>
</template>

<script>
    import allStores from '../stores/all';

    export default {
        mixins: [allStores],

        data() {
            return {
                signature: '',
                hasProfanity: false,
            };
        },

        computed: {
            personalizationValue() {
                return this.appStore.personalization;
            },

            isMobile() {
                return this.appStore.isMobile;
            },
        },

        beforeMount() {
            this.signature = this.personalizationValue;
        },

        methods: {
            enableEditSignature() {
                this.$nextTick(() => {
                    this.$refs.signature.focus();
                });
            },

            validateSignature() {
                let value = this.signature;

                // eslint-disable-next-line max-len, no-misleading-character-class
                const emojiAndNonPrintableRegex = /[^\u0020\u0021\u0022\u0023\u0024\u0025\u0026\u0027\u0028\u0029\u002A\u002B\u002C\u002D\u002E\u002F\u0030\u0031\u0032\u0033\u0034\u0035\u0036\u0037\u0038\u0039\u003A\u003B\u003C\u003D\u003E\u003F\u0040\u0041\u0042\u0043\u0044\u0045\u0046\u0047\u0048\u0049\u004A\u004B\u004C\u004D\u004E\u004F\u0050\u0051\u0052\u0053\u0054\u0055\u0056\u0057\u0058\u0059\u005A\u005B\u005C\u005D\u005E\u005F\u0060\u0061\u0062\u0063\u0064\u0065\u0066\u0067\u0068\u0069\u006A\u006B\u006C\u006D\u006E\u006F\u0070\u0071\u0072\u0073\u0074\u0075\u0076\u0077\u0078\u0079\u007A\u007B\u007C\u007D\u007E\u00A1\u00A2\u00A3\u00A4\u00A5\u00A6\u00A7\u00A8\u00A9\u00AB\u00AE\u00AF\u00B0\u00B1\u00B4\u00B6\u00B7\u00B8\u00BB\u00BF\u00C0\u00C1\u00C2\u00C3\u00C4\u00C5\u00C6\u00C7\u00C8\u00C9\u00CA\u00CB\u00CC\u00CD\u00CE\u00CF\u00D0\u00D1\u00D2\u00D3\u00D4\u00D5\u00D6\u00D7\u00D8\u00D9\u00DA\u00DB\u00DC\u00DD\u00DE\u00DF\u00E0\u00E1\u00E2\u00E3\u00E4\u00E5\u00E6\u00E7\u00E8\u00E9\u00EA\u00EB\u00EC\u00ED\u00EE\u00EF\u00F0\u00F1\u00F2\u00F3\u00F4\u00F5\u00F6\u00F7\u00F8\u00F9\u00FA\u00FB\u00FC\u00FD\u00FE\u00FF\u0100\u0101\u0102\u0103\u0104\u0105\u0106\u0107\u010A\u010B\u010C\u010D\u010E\u010F\u0110\u0111\u0112\u0113\u0116\u0117\u0118\u0119\u011A\u011B\u011E\u011F\u0120\u0121\u0122\u0123\u0126\u0127\u012A\u012B\u012E\u012F\u0130\u0131\u0132\u0133\u0136\u0137\u0139\u013A\u013B\u013C\u013D\u013E\u013F\u0140\u0141\u0142\u0143\u0144\u0145\u0146\u0147\u0148\u014A\u014B\u014C\u014D\u0150\u0151\u0152\u0153\u0154\u0155\u0156\u0157\u0158\u0159\u015A\u015B\u015E\u015F\u0160\u0161\u0162\u0163\u0164\u0165\u0166\u0167\u016A\u016B\u016E\u016F\u0170\u0171\u0172\u0173\u0174\u0175\u0176\u0177\u0178\u0179\u017A\u017B\u017C\u017D\u017E\u0218\u0219\u021A\u021B\u02C6\u02C7\u02D8\u02D9\u02DA\u02DB\u02DC\u02DD\u0300\u0301\u0302\u0303\u0304\u0306\u0307\u0308\u030A\u030B\u030C\u0312\u0326\u0327\u0328\u0394\u0398\u03A9\u1E80\u1E81\u1E82\u1E83\u1E84\u1E85\u1EF2\u1EF3\u2013\u2014\u2018\u2019\u201A\u201C\u201D\u201E\u2020\u2021\u2022\u2026\u2030\u2039\u203A\u2044\u20AC\u2122\u2190\u2191\u2192\u2193\u2194\u2195\u2196\u2197\u2198\u2199\u2205\u2212\u2248\u2260\u2264\u2265]/g;

                value = value.replace(emojiAndNonPrintableRegex, '');

                if (value.length > 16) {
                    value = value.substr(0, 16);
                }

                if (this.signature !== value) {
                    this.signature = value;
                }

                if (this.checkTimer) {
                    clearTimeout(this.checkTimer);
                    this.customizerStore.setPersonalizationCheckTimer(null);
                }

                this.checkTimer = setTimeout(() => {
                    if (this.signature !== '') {
                        const validationValue = this.signature;
                        const id = this.customizerStore.getPersonalizationTimerId();

                        // eslint-disable-next-line
                        console.log(`Check personalization ${validationValue} using ${id} timer`);

                        this.customizerStore.viewController.reviewText(validationValue).then((result) => {
                            this.customizerStore.setPersonalizationCheckTimer(null);

                            if (id !== this.customizerStore.personalizationTimerId) {
                                // eslint-disable-next-line
                                console.log(`Skip ${validationValue} since the timer got overridden, latest is ${this.customizerStore.personalizationTimerId}`);
                            } else if (result.hasProfanity) {
                                // eslint-disable-next-line
                                console.log(`'${validationValue}' failed validation`);

                                this.updateSignature('');
                                this.hasProfanity = true;
                                this.$emit('profanityChange', true);
                            } else {
                                // eslint-disable-next-line
                                console.log(`'${validationValue}' accepted`);

                                this.updateSignature(validationValue);
                                this.hasProfanity = false;
                                this.$emit('profanityChange', false);
                            }
                        }).catch(() => {
                            this.customizerStore.setPersonalizationCheckTimer(null);

                            this.hasProfanity = true;
                            this.$emit('profanityChange', true);
                        });
                    } else {
                        this.updateSignature('');
                    }
                }, 500);

                this.customizerStore.setPersonalizationCheckTimer(this.checkTimer);
            },

            updateSignature(signatureText) {
                const signature = signatureText;

                this.customizerStore.viewController.updatePersonalization('Personalization', signature).then((result) => {
                    if (result.accepted) {
                        if (result.as) {
                            if (this.signature.trim() !== result.as) {
                                this.signature = result.as;
                            }
                        }
                    } else if (result.lastValid) {
                        this.signature = result.lastValid;
                    }
                });

                this.appStore.setPersonalization(signature);
            },

            openKeyboard() {
                if (this.isMobile) {
                    this.appStore.toggleKeyboard(true);
                }
            },

            closeKeyboard() {
                if (this.isMobile) {
                    this.appStore.toggleKeyboard(false);
                }
            },
        },
    };
</script>
